import styled from "styled-components/macro";
import {
  MdArrowForwardIos,
  MdImage,
  MdMenu,
  MdPauseCircleFilled,
  MdPlayCircleFilled,
} from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import "../styles/Home.css";
import Topnav from "../components/Topnav";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import Footer from "../components/Footer";
import { formatEuroCents } from "../functions/formatEuroCents";
import { isEmpty } from "../functions/isEmpty";

export default function Home({
  products,
  cart,
  setCart,
  reviews,
  isMobile,
  language,
  setLanguage,
  texts,
}) {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [videoIsPlaying, setVideoIsPlaying] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  useEffect(() => {
    const ua = window.navigator.userAgent || "";
    const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    setIsIOS(iOS);
  }, []);

  const playpause = () => {
    if (videoRef.current) {
      if (videoIsPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setVideoIsPlaying(!videoIsPlaying);
    }
  };

  const scrollToObject = (objectstring) => {
    const object = document.getElementById(objectstring);
    if (object) {
      const offsetTop = object.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: offsetTop - 80, // 80px höher
        behavior: "smooth",
      });
    }
  };

  const handleProductClick = (product) => {
    window.scrollTo(0, 0);
    navigate("/product/" + product.id);
  };

  const handleAddToCart = (product) => {
    setCart((prevCart) => [...prevCart, product]);
  };

  return (
    <div className="home">
      <Topnav
        cart={cart}
        scrollToObject={scrollToObject}
        language={language}
        setLanguage={setLanguage}
        isMobile={isMobile}
      />
      <div className="home_banner">
        {language == "Deutsch" ? texts.de.banner : texts.en.banner}{" "}
      </div>

      <div className="home_section" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className="home_section_hero">
          {!isIOS ? (
            <video
              className="home_section_hero_right_video"
              ref={videoRef}
              playsInline
              autoPlay
              muted
              loop
              preload="metadata"
              poster=""
              onClick={() => playpause()}>
              <source src="/trailer.mp4" type="video/mp4" />
              Dein Browser unterstützt das Video-Tag nicht.
            </video>
          ) : (
            <img src="trailer.mp4" className="home_section_hero_right_video" />
          )}
        </div>
      </div>
      <div className="home_section">
        <div className="home_section_howitworks">
          <div className="home_section_howitworks_title"></div>
          <div className="home_section_howitworks_row"></div>
        </div>
      </div>
      <div className="home_section" style={{ padding: 0 }}>
        <div className="home_section_products" id="products">
          <div className="home_section_products_title">
            {language == "Deutsch"
              ? texts.de.products_headline
              : texts.en.products_headline}{" "}
          </div>
          <div className="home_section_products_row">
            {isEmpty(products) ? (
              <Spinner />
            ) : (
              products?.map((product, index) => (
                <div
                  key={product.id}
                  className="home_section_products_row_element"
                  onClick={() => handleProductClick(product)}>
                  <div className="home_section_products_row_element_imgbox">
                    <img
                      src={JSON.parse(product.images)[0]}
                      className="home_section_products_row_element_imgbox_img"
                    />
                  </div>
                  <div className="home_section_products_row_element_labelbox">
                    <div className="home_section_products_row_element_labelbox_top">
                      <div className="home_section_products_row_element_labelbox_top_left">
                        {" "}
                        {product.name}{" "}
                      </div>
                      <div className="home_section_products_row_element_labelbox_top_right">
                        {" "}
                        {isMobile && formatEuroCents(product.price)}
                      </div>
                    </div>
                    <div className="home_section_products_row_element_labelbox_bottom">
                      <div className="home_section_products_row_element_labelbox_bottom_left">
                        {!isMobile && formatEuroCents(product.price)}
                      </div>
                      <div
                        className="home_section_products_row_element_labelbox_bottom_right"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddToCart(product);
                        }}>
                        {language == "Deutsch"
                          ? texts.de.products_addtocart
                          : texts.en.products_addtocart}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/*
           <div className="home_section">
        <div className="home_section_reputation">
          <div className="home_section_reputation_title">
            {language == "Deutsch"
              ? texts.de.reputation_headline
              : texts.en.reputation_headline}{" "}
          </div>
          <div className="home_section_reputation_row">
            {reviews.map((review, index) => (
              <>
                {index < 2 && (
                  <div
                    className="home_section_reputation_row_element"
                    key={review.id}>
                    <div className="home_section_reputation_row_element_left">
                      <img
                        src={review.image}
                        className="home_section_reputation_row_element_left_img"
                      />
                    </div>
                    <div className="home_section_reputation_row_element_right">
                      <div className="home_section_reputation_row_element_right_top">
                        {review.title}
                      </div>
                      <div className="home_section_reputation_row_element_right_bottom">
                        {language == "Deutsch"
                          ? texts.de.reputation_1
                          : texts.en.reputation_1}
                      </div>
                      <div className="home_section_reputation_row_element_right_name">
                        {review.name}
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}
          </div>
          <div className="home_section_reputation_row">
            {reviews.map((review, index) => (
              <>
                {index >= 2 && (
                  <div
                    className="home_section_reputation_row_element"
                    key={review.id}>
                    <div className="home_section_reputation_row_element_left">
                      <img
                        src={review.image}
                        className="home_section_reputation_row_element_left_img"
                      />
                    </div>
                    <div className="home_section_reputation_row_element_right">
                      <div className="home_section_reputation_row_element_right_top">
                        {review.title}
                      </div>
                      <div className="home_section_reputation_row_element_right_bottom">
                        {language == "Deutsch"
                          ? texts.de.reputation_2
                          : texts.en.reputation_2}{" "}
                      </div>
                      <div className="home_section_reputation_row_element_right_name">
                        {review.name}
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}
          </div>
                  </div>
      </div>

          */}
      <div className="home_section" style={{ paddingLeft: 0 }}>
        <div className="home_section_social">
          <div className="home_section_social_title">Social Media</div>
          <div className="home_section_social_row">
            <div className="home_section_social_row_element">
              <img
                src="social_placeholder.jpg"
                className="home_section_social_row_element_img"
              />
            </div>
            <div className="home_section_social_row_element">
              <img
                src="social_placeholder.jpg"
                className="home_section_social_row_element_img"
              />
            </div>
            <div className="home_section_social_row_element">
              <img
                src="social_placeholder.jpg"
                className="home_section_social_row_element_img"
              />
            </div>
            <div className="home_section_social_row_element">
              <img
                src="social_placeholder.jpg"
                className="home_section_social_row_element_img"
              />
            </div>
            <div className="home_section_social_row_element">
              <img
                src="social_placeholder.jpg"
                className="home_section_social_row_element_img"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="home_section">
        <div className="home_section_faq">
          <div className="home_section_faq_title">
            {" "}
            {language == "Deutsch"
              ? texts.de.faq_headline
              : texts.en.faq_headline}
          </div>
          <div className="home_section_faq_element">
            <div className="home_section_faq_element_question">
              {language == "Deutsch" ? texts.de.faq_q1 : texts.en.faq_q1}{" "}
            </div>
            <div className="home_section_faq_element_answer">
              {language == "Deutsch" ? texts.de.faq_a1 : texts.en.faq_a1}{" "}
            </div>
          </div>
          <div className="home_section_faq_element">
            <div className="home_section_faq_element_question">
              {language == "Deutsch" ? texts.de.faq_q2 : texts.en.faq_q2}
            </div>
            <div className="home_section_faq_element_answer">
              {language == "Deutsch" ? texts.de.faq_a2 : texts.en.faq_a2}{" "}
            </div>
          </div>
        </div>
      </div>
      <Footer texts={texts} language={language} />
    </div>
  );
}
const PlayIcon = styled(MdPlayCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const PauseIcon = styled(MdPauseCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;
